import { z } from 'zod';
import { CardEnum } from '../CardState.ts';
import { createTradeIdKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
export const tradeOfferClosedStateSchema = z.object({
    offeredResources: z.array(z.enum(CardEnum)).readonly(),
    wantedResources: z.array(z.enum(CardEnum)).readonly()
}).strict();
export function validateTradeOfferClosedState(data) {
    return validateState(tradeOfferClosedStateSchema, data);
}
export const tradeClosedOffersSchema = createTradeIdKeyRecordSchema(tradeOfferClosedStateSchema);
export function validateTradeClosedOffers(data) {
    return validateState(tradeClosedOffersSchema, data);
}
export const tradeOfferClosedStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tradeOfferClosedStateSchema);
const tradeClosedOfferPartialValueSchema = z.union([
    tradeOfferClosedStatePartialSchema,
    z.null()
]);
export const tradeClosedOffersPartialSchema = createTradeIdKeyRecordSchema(tradeClosedOfferPartialValueSchema, {
    requireAtLeastOneEntry: true
});
export function validateTradeClosedOffersPartial(data) {
    return validateState(tradeClosedOffersPartialSchema, data);
}
